import { type ReactNode, useId } from "react";

import styles from "./NavItemV2.module.css";

import { IconV2, type IconV2Name } from "@/components/atoms/IconV2";

interface Props {
  icon: IconV2Name;
  label: string;
  onClick: () => void;
  active?: boolean;
  chip?: ReactNode;
}

export const NavItemV2 = ({
  icon,
  label,
  onClick,
  active = false,
  chip,
}: Props) => {
  const chipId = useId();

  return (
    <button
      type="button"
      className={styles.navItem}
      data-active={active || undefined}
      aria-current={active ? "page" : undefined}
      aria-describedby={chip === undefined ? undefined : chipId}
      onClick={onClick}
    >
      <IconV2 name={icon} size="m" />
      <span className={styles.label}>{label}</span>
      {chip !== undefined && (
        <span id={chipId} aria-hidden>
          {chip}
        </span>
      )}
    </button>
  );
};
